import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c28b8d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-preview selected" }
const _hoisted_2 = { class: "image-wrapper new-chat" }
const _hoisted_3 = { class: "chat" }
const _hoisted_4 = { class: "chat-name" }
const _hoisted_5 = { class: "information" }
const _hoisted_6 = { class: "date" }

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatPreviewNew',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Icon, {
        icon: _unref(IconType).DEFAULT_SINGLE_GRAY,
        alt: "user"
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("chat.chatSidebar.NewChatPreview.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("date.today")), 1)
    ])
  ]))
}
}

})